<template>
  <div class="container-md">
    <div class="row justify-content-center">
      <div class="col-auto px-5">
        <div class="py-3 text-center">
          <h3>{{ $t("signUp.title") }}</h3>
        </div>

        <form class="border bg-light p-3" @submit.prevent="submit" novalidate>
          <p class="message p-2">{{ $t("signUp.message") }}</p>

          <div class="p-2">
            <label for="personalName">
              {{ $t("signUp.personalName") }}
              <label for="" class="text-danger">{{ $t("signUp.required") }}</label>
            </label>
            <input type="text" maxlength="20" class="form-control" id="personalName" v-model.trim="inputPersonalName" @blur="validatePersonalName">
            <p class="text-danger" v-if="isPersonalError">{{ $t("error.noInput") }}</p>
          </div>

          <div class="p-2">
            <label for="dateOfBirth">
              {{ $t("signUp.dateOfBirth") }}
              <label for="" class="text-danger">{{ $t("signUp.required") }}</label>
            </label>
            <!-- <input type="date" max="9999-12-31" class="form-control icon-del" id="dateOfBirth" v-model="inputBirth" @blur="validateBirth">
            <p class="text-danger" v-if="isBirthError">{{ $t("error.noInput") }}</p> -->
            <date-dropdown :default="inputBirth" min="1900" max="2100" @setInputBirth="setInputBirth" @blur="validateBirth" />
            <p class="text-muted mb-0">{{ $t("signUp.conditionBirth") }}</p>
            <p class="text-danger" v-if="isBirthError">{{ $t("error.noInput") }}</p>
          </div>

        <div class="p-2">
           <label for="pref">
           {{ $t("signUpConfirm.prefectures") }}
           <label for="" class="text-danger">{{ $t("signUp.required") }}</label>
          </label>
          <select id="pref" class="form-control selectPref" v-model="inputPrefectures" @blur="validatePrefectures">
            <option :value="$t('signUp.selectable')" disabled>{{ $t("signUp.selectable") }}</option>
            <option :value="$t('signUp.hokkaido')">{{ $t("signUp.hokkaido") }}</option>
            <option :value="$t('signUp.aomori')">{{ $t("signUp.aomori") }}</option>
            <option :value="$t('signUp.iwate')">{{ $t("signUp.iwate") }}</option>
            <option :value="$t('signUp.miyagi')">{{ $t("signUp.miyagi") }}</option>
            <option :value="$t('signUp.akita')">{{ $t("signUp.akita") }}</option>
            <option :value="$t('signUp.yamagata')">{{ $t("signUp.yamagata") }}</option>
            <option :value="$t('signUp.fukushima')">{{ $t("signUp.fukushima") }}</option>
            <option :value="$t('signUp.gunma')">{{ $t("signUp.gunma") }}</option>
            <option :value="$t('signUp.tochigi')">{{ $t("signUp.tochigi") }}</option>
            <option :value="$t('signUp.ibaraki')">{{ $t("signUp.ibaraki") }}</option>
            <option :value="$t('signUp.saitama')">{{ $t("signUp.saitama") }}</option>
            <option :value="$t('signUp.chiba')">{{ $t("signUp.chiba") }}</option>
            <option :value="$t('signUp.tokyo')">{{ $t("signUp.tokyo") }}</option>
            <option :value="$t('signUp.kanagawa')">{{ $t("signUp.kanagawa") }}</option>
            <option :value="$t('signUp.niigata')">{{ $t("signUp.niigata") }}</option>
            <option :value="$t('signUp.toyama')">{{ $t("signUp.toyama") }}</option>
            <option :value="$t('signUp.ishikawa')">{{ $t("signUp.ishikawa") }}</option>
            <option :value="$t('signUp.fukui')">{{ $t("signUp.fukui") }}</option>
            <option :value="$t('signUp.yamanashi')">{{ $t("signUp.yamanashi") }}</option>
            <option :value="$t('signUp.nagano')">{{ $t("signUp.nagano") }}</option>
            <option :value="$t('signUp.gifu')">{{ $t("signUp.gifu") }}</option>
            <option :value="$t('signUp.shizuoka')">{{ $t("signUp.shizuoka") }}</option>
            <option :value="$t('signUp.aichi')">{{ $t("signUp.aichi") }}</option>
            <option :value="$t('signUp.mie')">{{ $t("signUp.mie") }}</option>
            <option :value="$t('signUp.shiga')">{{ $t("signUp.shiga") }}</option>
            <option :value="$t('signUp.kyoto')">{{ $t("signUp.kyoto") }}</option>
            <option :value="$t('signUp.osaka')">{{ $t("signUp.osaka") }}</option>
            <option :value="$t('signUp.hyogo')">{{ $t("signUp.hyogo") }}</option>
            <option :value="$t('signUp.nara')">{{ $t("signUp.nara") }}</option>
            <option :value="$t('signUp.wakayama')">{{ $t("signUp.wakayama") }}</option>
            <option :value="$t('signUp.tottori')">{{ $t("signUp.tottori") }}</option>
            <option :value="$t('signUp.shimane')">{{ $t("signUp.shimane") }}</option>
            <option :value="$t('signUp.okayama')">{{ $t("signUp.okayama") }}</option>
            <option :value="$t('signUp.hiroshima')">{{ $t("signUp.hiroshima") }}</option>
            <option :value="$t('signUp.yamaguchi')">{{ $t("signUp.yamaguchi") }}</option>
            <option :value="$t('signUp.tokushima')">{{ $t("signUp.tokushima") }}</option>
            <option :value="$t('signUp.kagawa')">{{ $t("signUp.kagawa") }}</option>
            <option :value="$t('signUp.ehime')">{{ $t("signUp.ehime") }}</option>
            <option :value="$t('signUp.kochi')">{{ $t("signUp.kochi") }}</option>
            <option :value="$t('signUp.fukuoka')">{{ $t("signUp.fukuoka") }}</option>
            <option :value="$t('signUp.saga')">{{ $t("signUp.saga") }}</option>
            <option :value="$t('signUp.nagasaki')">{{ $t("signUp.nagasaki") }}</option>
            <option :value="$t('signUp.kumamoto')">{{ $t("signUp.kumamoto") }}</option>
            <option :value="$t('signUp.oita')">{{ $t("signUp.oita") }}</option>
            <option :value="$t('signUp.miyazaki')">{{ $t("signUp.miyazaki") }}</option>
            <option :value="$t('signUp.kagoshima')">{{ $t("signUp.kagoshima") }}</option>
            <option :value="$t('signUp.okinawa')">{{ $t("signUp.okinawa") }}</option>
            <option :value="$t('signUp.other')">{{ $t("signUp.other") }}</option>
          </select>
          <p class="text-danger" v-if="isPrefecturesError">{{ $t("error.noInput") }}</p>
       </div>

          <div class="p-2">
            <label for="city">
              {{ $t("signUp.city") }}
              <label for="" class="text-danger">{{ $t("signUp.required") }}</label>
            </label>
            <input type="text" maxlength="10" class="form-control" id="city" v-model.trim="inputCity" @blur="validateCity">
            <p class="text-danger" v-if="isCityError">{{ $t("error.noInput") }}</p>
          </div>

          <div class="p-2">
            <label for="gender">
              {{ $t("signUp.gender") }}
              <label for="" class="text-danger">{{ $t("signUp.required") }}</label>
            </label>
            <div class="form-check">
              <input type="radio" class="form-check-input" name="gender" id="male" value="M" v-model="inputGender" @blur="validateGender">
              <label class="form-check-label" for="male">{{ $t("signUp.male") }}</label>
            </div>
            <div class="form-check">
              <input type="radio" class="form-check-input" name="gender" id="female" value="F" v-model="inputGender" @blur="validateGender">
              <label class="form-check-label" for="female">{{ $t("signUp.female") }}</label>
            </div>
            <div class="form-check">
              <input type="radio" class="form-check-input" name="gender" id="notKnown" value="N" v-model="inputGender" @blur="validateGender">
              <label class="form-check-label" for="notKnown">{{ $t("signUp.notKnown") }}</label>
            </div>
            <p class="text-danger" v-if="isGenderError">{{ $t("error.noInput") }}</p>
          </div>

          <div class="p-2">
            <label for="phoneNumber">
              {{ $t("signUp.phoneNumber") }}
              <label for="" class="text-danger">{{ $t("signUp.required") }}</label>
            </label>
            <input type="tel" minlength="10" maxlength="16" class="form-control" id="phoneNumber" v-model.trim="inputPhoneNumber" @blur="validatePhoneNumber">
            <p class="text-danger mb-0" v-show="isPhoneNumberError">{{ $t("signUp.phoneNumberError") }}</p>
          </div>

          <div class="p-2">
            <label for="email">
              {{ $t("common.email") }}
              <label for="" class="text-danger">{{ $t("signUp.required") }}</label>  
            </label>
            <label for="email" class="form-control">{{ inputEmail }}</label>
          </div>

          <div class="p-2">
            <label for="password">
              {{ $t("common.password") }}
              <label for="" class="text-danger">{{ $t("signUp.required") }}</label>
            </label>
            <input type="password" maxlength="100" class="form-control" id="password" v-model.trim="inputPassword" @blur="validatePassword">
            <p class="text-danger" v-show="isPasswordError">{{ $t("signUp.passwordError") }}</p>
          </div>
          
          <div class="p-2">
            <label for="passwordConfirm">{{ $t("signUp.passwordConfirm") }}</label>
            <input type="password" class="form-control" id="passwordConfirm" v-model.trim="inputPasswordConfirm" @blur="collatePassword">
            <p class="text-danger" v-show="isPasswordConfirmError">{{ $t("signUp.passwordConfirmError") }}</p>
          </div>
          
          <div class="p-2">
            <label for="companyName">{{ $t("signUp.companyName") }}</label>
            <input type="text" maxlength="50" class="form-control" id="companyName" v-model="inputCompanyName">
          </div>

          <div class="p-2">
            <label>{{ $t("signUp.termsTitle") }}</label>
            <p class="text-muted mb-1 terms-hint">{{ $t("signUp.termsScrollHint") }}</p>
            <div class="terms-wrapper">
              <div class="terms-box form-control" id="termsText" @scroll="onTermsScroll" ref="termsBoxRef">{{ termsText }}</div>
              <div class="terms-fade" v-if="showTermsFade"></div>
            </div>
            <div class="form-check mt-2">
              <input type="checkbox" class="form-check-input" id="termsAgreed" v-model="inputTermsAgreed" @change="validateTerms">
              <label class="form-check-label" for="termsAgreed">{{ $t("signUp.termsAgree") }}</label>
            </div>
            <p class="text-danger" v-if="isTermsError">{{ $t("signUp.termsError") }}</p>
          </div>

          <div class="d-grid gap-2 p-2 mt-2">
            <button type="submit" class="btn btn-primary" :disabled="isButtonDisabled">{{ $t("signUp.confirm") }}</button>
          </div>
        </form>
      </div>
    </div>    
  </div>
</template>

<script>
import Const from '../const.js'
import parsePhoneNumber from 'libphonenumber-js'
import axios from 'axios'
import DateDropdown from './DateDropdown.vue'

export default {
  props: {
    default: { default: ""}
  },
  components: { DateDropdown },
  data() {
    return {
      inputPersonalName: "",
      inputBirth: "",
      inputGender: "",
      inputPhoneNumber: "",
      inputEmail: "",
      inputPassword: "",
      inputPasswordConfirm: "",
      inputCompanyName: "",
      inputPrefectures: "",
      inputCity: "",
      formatPhoneNumber: "",
      isPersonalError: false,
      isBirthError: false,
      isGenderError: false,
      isPhoneNumberError: false,
      isEmailError: false,
      isPasswordError: false,
      isPasswordConfirmError: false,
      isButtonDisabled: false,
      isPrefecturesError: false,
      isCityError: false,
      inputTermsAgreed: false,
      isTermsError: false,
      termsText: "",
      showTermsFade: true
    }
  },
  
  methods: {
    submit() {
      this.isButtonDisabled = true
      this.isPersonalError = false
      this.isBirthError = false
      this.isGenderError = false
      this.isPhoneNumberError = false
      this.isEmailError = false
      this.isPasswordError = false
      this.isPasswordConfirmError = false
      this.isPrefecturesError = false
      this.isCityError = false
      this.isTermsError = false

      this.validatePersonalName()
      this.validateBirth()
      this.validateGender()
      this.validatePhoneNumber()
      this.validatePassword()
      this.collatePassword()
      this.validatePrefectures()
      this.validateCity()
      this.validateTerms()

      if (
        this.isPersonalError ||
        this.isBirthError ||
        this.isGenderError ||
        this.isPhoneNumberError ||
        this.isEmailError ||
        this.isPasswordError ||
        this.isPasswordConfirmError ||
        this.isPrefecturesError ||
        this.isCityError ||
        this.isTermsError
        ) {
        this.isButtonDisabled = false
        return
      }

      this.$store.dispatch("updatePersonalName", this.inputPersonalName)
      this.$store.dispatch("updateBirth", this.inputBirth)
      this.$store.dispatch("updateGender", this.inputGender)
      this.$store.dispatch("updatePhoneNumber", this.inputPhoneNumber)
      this.$store.dispatch("updateFormatPhoneNumber", this.formatPhoneNumber)
      this.$store.dispatch("updateEmail", this.inputEmail)
      this.$store.dispatch("updatePassword", this.inputPassword)
      this.$store.dispatch("updateCompanyName", this.inputCompanyName)
      this.$store.dispatch("updatePrefectures", this.inputPrefectures)
      this.$store.dispatch("updateCity", this.inputCity)

      this.$router.push({ name: "signUpConfirm" })
    },

    setInputBirth(val) {
      this.inputBirth = val
    },

    validatePersonalName() {
      if (!this.inputPersonalName) {
        this.isPersonalError = true
      } else {
        this.isPersonalError = false
      }
    },

    validateBirth() {
      if (!this.inputBirth) {
        this.isBirthError = true
      } else {
        this.isBirthError = false
      }
    },

    validateGender() {
      if (!this.inputGender) {
        this.isGenderError = true
      } else {
        this.isGenderError = false
      }
    },

    validatePassword() {
      const regexp = new RegExp(Const.REGEXP_FOR_PASSWORD)
      
      if (!this.inputPassword || !regexp.test(this.inputPassword)) {
        this.isPasswordError = true
      } else {
        this.isPasswordError = false
      }
    },

    validatePhoneNumber() {
      this.formatPhoneNumber = this.toHalfSize(this.inputPhoneNumber)
      const phoneNumber = parsePhoneNumber(this.formatPhoneNumber, "JP")
     
      if (this.inputPhoneNumber && phoneNumber && phoneNumber.isValid()) {
        this.isPhoneNumberError = false
      } else {
        this.isPhoneNumberError = true
      }
    },

    collatePassword() {
      if(this.inputPassword !== this.inputPasswordConfirm) {
        this.isPasswordConfirmError = true
      } else {
        this.isPasswordConfirmError = false
      }
    },
    // 全角数字 -> 半角数字
    toHalfSize(str) {
      return str.replace(/[０-９]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
     })
    },
    validatePrefectures() {
      if (this.inputPrefectures == this.$t("signUp.selectable")) {
        this.isPrefecturesError = true
      } else {
        this.isPrefecturesError = false
      }
    },
    validateCity() {
      if (!this.inputCity) {
        this.isCityError = true
      } else {
        this.isCityError = false
      }
    },

    validateTerms() {
      if (!this.inputTermsAgreed) {
        this.isTermsError = true
      } else {
        this.isTermsError = false
      }
    },

    onTermsScroll(e) {
      const el = e.target
      this.showTermsFade = el.scrollTop + el.clientHeight < el.scrollHeight - 2
    },
  },

  created() {
    // signUpConfirm以外から遷移してきたか判定
    if (this.$router.referrer.name != "signUpConfirm") {
      this.$store.dispatch("clearAll")
    }

    if (this.$route.query.token) {
      this.$store.dispatch('updateToken', this.$route.query.token)
    }

    axios.get(process.env.BASE_URL + 'terms.txt')
      .then(function(response) {
        this.termsText = response.data
      }.bind(this))
      .catch(function() {
        this.termsText = ""
      }.bind(this))

    axios.post(Const.BASE_URL + '/authentication-email', "", {
      headers: {
        "Authorization": this.$store.getters.token,
        "Content-Type": "application/json"
        }
    })
    .then(function(response) {
      // console.log(response)
      this.inputEmail = response.data.context
    }.bind(this))
    .catch(function() {
      // console.log(error)
      this.$store.dispatch("updateTokenError", true)
      this.$router.push({ name: "login" })
    }.bind(this))

    this.inputPersonalName = this.$store.getters.personalName
    this.inputBirth = this.$store.getters.birth
    this.inputGender = this.$store.getters.gender
    this.inputPhoneNumber = this.$store.getters.phoneNumber
    this.inputEmail = this.$store.getters.email
    this.inputCompanyName = this.$store.getters.companyName
    if (this.$store.getters.prefectures != "") {
      this.inputPrefectures = this.$store.getters.prefectures
    } else {
      this.inputPrefectures = this.$t("signUp.selectable")
    }
    this.inputCity = this.$store.getters.city
  }
}
</script>

<style scoped>
p {
  margin: 0;
}
.selectPref {
  -moz-appearance: menulist;
  -webkit-appearance: menulist;
}
.terms-hint {
  font-size: 0.8rem;
}
.terms-wrapper {
  position: relative;
}
.terms-box {
  max-height: 200px;
  overflow-y: auto;
  white-space: pre-wrap;
  background-color: #fff;
  font-size: 0.875rem;
}
.terms-fade {
  position: absolute;
  left: 1px;
  right: 1px;
  bottom: 1px;
  height: 40px;
  background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.95));
  pointer-events: none;
  border-radius: 0 0 0.25rem 0.25rem;
}
</style>
